// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={114}
    height={114}
    viewBox="0 0 114 114"
    {...props}
  >
    <path
      d="M91.4163 30.6791H1.7648V25.4055C1.7648 24.0069 2.32038 22.6655 3.30938 21.6765C4.29837 20.6875 5.63977 20.1319 7.03842 20.1319H86.1427C87.5413 20.1319 88.8827 20.6875 89.8717 21.6765C90.8607 22.6655 91.4163 24.0069 91.4163 25.4055V30.6791Z"
      fill="#FF73A9"
    />
    <path
      d="M86.1427 91.3257H7.03842C5.63977 91.3257 4.29837 90.7701 3.30938 89.7811C2.32038 88.7921 1.7648 87.4507 1.7648 86.0521V30.6791H91.4163V86.0521C91.4163 87.4507 90.8607 88.7921 89.8717 89.7811C88.8827 90.7701 87.5413 91.3257 86.1427 91.3257Z"
      fill="#FFD5E1"
    />
    <path
      d="M91.4168 80.7786H14.9494C13.5507 80.7786 12.2094 80.2231 11.2204 79.2341C10.2314 78.2451 9.67578 76.9037 9.67578 75.505V30.6793H91.4168V80.7786Z"
      fill="#FF9DBE"
    />
    <path
      d="M91.4168 20.1319H9.67578V30.6791H91.4168V20.1319Z"
      fill="#F95396"
    />
    <path
      d="M91.4163 30.6791H1.7648V25.4055C1.7648 24.0069 2.32038 22.6655 3.30938 21.6765C4.29837 20.6875 5.63977 20.1319 7.03842 20.1319H86.1427C87.5413 20.1319 88.8827 20.6875 89.8717 21.6765C90.8607 22.6655 91.4163 24.0069 91.4163 25.4055V30.6791Z"
      stroke="#29292F"
      strokeWidth={2.125}
      strokeLinejoin="round"
    />
    <path
      d="M86.1427 91.3257H7.03842C5.63977 91.3257 4.29837 90.7701 3.30938 89.7811C2.32038 88.7921 1.7648 87.4507 1.7648 86.0521V30.6791H91.4163V86.0521C91.4163 87.4507 90.8607 88.7921 89.8717 89.7811C88.8827 90.7701 87.5413 91.3257 86.1427 91.3257V91.3257Z"
      stroke="#29292F"
      strokeWidth={2.125}
      strokeLinejoin="round"
    />
    <path
      d="M107.238 12.2215H17.5868V6.94787C17.5868 5.54922 18.1424 4.20783 19.1314 3.21883C20.1204 2.22984 21.4618 1.67426 22.8604 1.67426H101.965C103.363 1.67426 104.705 2.22984 105.694 3.21883C106.683 4.20783 107.238 5.54922 107.238 6.94787V12.2215Z"
      fill="#FF73A9"
      stroke="#29292F"
      strokeWidth={2.125}
      strokeLinejoin="round"
    />
    <path
      d="M101.965 72.8681H22.8604C21.4618 72.8681 20.1204 72.3125 19.1314 71.3235C18.1424 70.3345 17.5868 68.9931 17.5868 67.5945V12.2215H107.238V67.5945C107.238 68.9931 106.683 70.3345 105.694 71.3235C104.705 72.3125 103.363 72.8681 101.965 72.8681Z"
      fill="#FCFBF7"
      stroke="#29292F"
      strokeWidth={2.125}
      strokeLinejoin="round"
    />
    <path
      d="M91.4162 9.58465C92.8725 9.58465 94.053 8.40411 94.053 6.94784C94.053 5.49157 92.8725 4.31104 91.4162 4.31104C89.96 4.31104 88.7794 5.49157 88.7794 6.94784C88.7794 8.40411 89.96 9.58465 91.4162 9.58465Z"
      fill="#29292F"
    />
    <path
      d="M99.3256 9.58465C100.782 9.58465 101.962 8.40411 101.962 6.94784C101.962 5.49157 100.782 4.31104 99.3256 4.31104C97.8694 4.31104 96.6888 5.49157 96.6888 6.94784C96.6888 8.40411 97.8694 9.58465 99.3256 9.58465Z"
      fill="#29292F"
    />
    <path
      d="M57.1381 22.7687H30.77C29.3138 22.7687 28.1332 23.9492 28.1332 25.4055V59.684C28.1332 61.1403 29.3138 62.3208 30.77 62.3208H57.1381C58.5944 62.3208 59.7749 61.1403 59.7749 59.684V25.4055C59.7749 23.9492 58.5944 22.7687 57.1381 22.7687Z"
      fill="#FF73A9"
      stroke="#29292F"
      strokeWidth={2.125}
      strokeLinejoin="round"
    />
    <path
      d="M94.0531 38.5895H70.3218C68.8656 38.5895 67.685 39.7701 67.685 41.2263V59.684C67.685 61.1403 68.8656 62.3208 70.3218 62.3208H94.0531C95.5094 62.3208 96.6899 61.1403 96.6899 59.684V41.2263C96.6899 39.7701 95.5094 38.5895 94.0531 38.5895Z"
      fill="#FF73A9"
      stroke="#29292F"
      strokeWidth={2.125}
      strokeLinejoin="round"
    />
    <path
      d="M67.5213 22.899H96.8192"
      stroke="#29292F"
      strokeWidth={2.125}
    />
    <path
      d="M67.5213 32.665H96.8192"
      stroke="#29292F"
      strokeWidth={2.125}
    />
    <path
      d="M67.5213 27.782H96.8192"
      stroke="#29292F"
      strokeWidth={2.125}
    />
  </svg>
);
const SvgSmallScreen = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgSmallScreen;
